const Home = () => import('Pages/Home/Home.vue')
const ModelRoom = () => import('Pages/Home/ModelRoom.vue')
const BroadcastRoom = () => import('Pages/Home/BroadcastRoom.vue')
const About = () => import('Pages/Home/About.vue')
const BuyTokens = () => import('Pages/Home/Buy-tokens.vue')
const MLanding = () => import('Pages/Landing/model-landing.vue')
const Static = () => import('Pages/Home/Static.vue')
const Howitworks = () => import('Pages/Home/Howitworks.vue')

export default [
  /* Front End Routes */
  {
    path: '/about',
    component: About,
    name: 'about',
    meta: {
      permission: 'guest',
      fail: '/404.html'
    }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      permission: 'guest',
      fail: '/404.html'
    }
  },
  {
    path: '/model/:id',
    name: 'modelRoom',
    component: ModelRoom,
    props: true,
    meta: {
      permission: 'guest',
      fail: '/404.html'
    }
  },
  {
    path: '/broadcast',
    name: 'broadcastRoom',
    component: BroadcastRoom,
    meta: {
      permission: 'guest'
      //fail: "/404.html"
    }
  },
  {
    path: '/buycredits',
    component: BuyTokens,
    name: 'buy tokens',
    meta: {
      permission: 'guest',
      fail: '/404.html'
    }
  },
  {
    path: '/mlanding',
    component: MLanding,
    name: 'Model Landing',
    meta: {
      permission: 'guest'
      //fail: "/404.html"
    }
  },
  {
    path: '/how-it-works',
    component: Howitworks,
    name: 'how-it-works',
    meta: {
      permission: 'guest'
    }
  },
  {
    path: '/customer-support',
    component: Static,
    name: 'customer-support',
    meta: {
      permission: 'guest'
    },
    props: {
      page: 'customer-support',
      language: 'en'
    }
  },
  {
    path: '/terms-and-conditions',
    component: Static,
    name: 'terms-and-conditions',
    meta: {
      permission: 'guest'
    },
    props: {
      page: 'terms-and-conditions',
      language: 'en'
    }
  },
  {
    path: '/privacy-policy',
    component: Static,
    name: 'privacy-policy',
    meta: {
      permission: 'guest'
    },
    props: {
      page: 'privacy-policy',
      language: 'en'
    }
  },
  {
    path: '/studio-terms-and-conditions',
    component: Static,
    name: 'studio-terms-and-conditions',
    meta: {
      permission: 'guest'
    },
    props: {
      page: 'studio-terms-and-conditions',
      language: 'en'
    }
  },
  {
    path: '/2257',
    component: Static,
    name: '2257',
    meta: {
      permission: 'guest'
    },
    props: {
      page: '2257',
      language: 'en'
    }
  },
  {
    path: '/dmca',
    component: Static,
    name: 'dmca',
    meta: {
      permission: 'guest'
    },
    props: {
      page: 'dmca',
      language: 'en'
    }
  },
  {
    path: '/subpoena',
    component: Static,
    name: 'subpoena',
    meta: {
      permission: 'guest'
    },
    props: {
      page: 'subpoena',
      language: 'en'
    }
  },
  {
    path: '/how-it-works-mobile',
    component: Static,
    name: 'how-it-works-mobile',
    meta: {
      permission: 'guest'
    },
    props: {
      page: 'how-it-works-mobile',
      language: 'en'
    }
  }
]



// WEBPACK FOOTER //
// ./resources/js/routes/home/index.js